<template>
  <div class="default-modal order-reason-change-model">
    <el-dialog
      top="25vh"
      :width="currentWidth"
      v-model="visible"
      :title="displayTitle"
      @close="close"
      :close-on-click-modal="false"
    >
      <div class="dialog-header">
        <div class="header-part">
          <span v-html="displayTitleChanged"></span>
        </div>
        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="close"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
        </el-button>
      </div>
      <div class="popup-date pb-0">
        <el-form ref="ruleForm" :model="formData">
          <el-form-item prop="selectedReasons">
            <el-select
              v-model="formData.selectedReasons"
              placeholder="Choose reasons"
              multiple
              filterable
              allow-create
              default-first-option
              @change="updateNotes"
            >
              <el-option
                v-for="reason in predefinedReasons"
                :key="reason.value"
                :label="reason.label"
                :value="reason.value"
              />
            </el-select>
          </el-form-item>
          <br />
          <el-form-item prop="notes">
            <el-input
              v-model="formData.notes"
              type="textarea"
              rows="3"
              placeholder="Enter notes"
            />
            <p><b>Note :</b> Minimum 3 characters are required</p>
          </el-form-item>
          <el-form-item prop="image" label="Attach Image (Required)">
            <el-upload
              class="upload-demo"
              :auto-upload="false"
              :on-change="handleImageChange"
              :on-remove="handleImageRemove"
              :file-list="fileList"
              :limit="1"
              accept="image/*"
              :show-file-list="true"
            >
              <el-button type="primary" v-if="!formData.image">Select Image</el-button>
              <template #tip>
                <div class="el-upload__tip" v-if="!formData.image">Image file is required</div>
              </template>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="dialog-footer pt-0">
          <el-button
            class="blue-save-button"
            :disabled="checkReason"
            @click="submit('ruleForm')"
          >
            SUBMIT
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  predefinedReasons,
  reasonToActionMap,
} from "@/config/constants/rejectionReasons";

export default {
  props: {
    title: {
      default: "",
    },
    width: {
      default: 30,
    },
  },
  data() {
    return {
      displayTitle: this.displayTitleChanged,
      visible: true,
      currentWidth: "30%",
      formData: {
        selectedReasons: [], // New property for selected reasons (multiple)
        notes: "",
        image: null,
      },
      fileList: [],
      predefinedReasons,
      reasonToActionMap,
    };
  },
  mounted() {
    if (this.width) {
      this.currentWidth = this.width + "%";
    }
  },
  computed: {
    checkReason() {
      const areReasonsEmpty = this.formData.selectedReasons.length === 0;
      const isNotesEmpty = !this.formData.notes.trim();
      const isNotesValid = this.formData.notes.length >= 3;
      const isImageMissing = !this.formData.image;

      return areReasonsEmpty || isNotesEmpty || !isNotesValid || isImageMissing;
    },
    displayTitleChanged() {
      return `Reason for change  <span class="red-text">to ${this.title}</span>`;
    },
  },

  methods: {
    handleImageChange(file) {
      this.formData.image = file.raw;
      this.fileList = [file];
    },
    handleImageRemove() {
      this.formData.image = null;
      this.fileList = [];
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.visible = false;
          const data = {
            reasons: this.formData.selectedReasons,
            image: this.formData.image,
          };
          if (this.formData.notes != "") {
            data.notes = this.formData.notes;
          }
          this.$emit("reasonSubmit", data);
        } else {
          return false;
        }
      });
    },
    close() {
      this.$emit("close");
    },
    updateNotes() {
      const actions = this.formData.selectedReasons
        .map((reason) => this.reasonToActionMap[reason])
        .filter((action) => action);
      this.formData.notes = actions.join("\n");
    },
  },
};
</script>

<style lang="scss">
.red-text {
  color: red;
  text-transform: capitalize;
}
.el-select .el-select__tags > span {
  flex-wrap: wrap !important;
}
.order-reason-change-model .el-select__tags {
  flex-wrap: wrap !important;
}
.upload-demo {
  width: 100%;
}
.el-upload__tip {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}
.order-reason-change-model .el-upload-list__item {
  margin-left: 0 !important;
  padding-left: 0 !important;
}
</style>
